import { __extends } from "tslib";
import { ASObject, axCoerceString } from '@awayfl/avm2';
var ElementFormat = /** @class */ (function (_super) {
    __extends(ElementFormat, _super);
    function ElementFormat(fontDescription, fontSize, color, alpha, textRotation, dominantBaseline, alignmentBaseline, baselineShift, kerning, trackingRight, trackingLeft, locale, breakOpportunity, digitCase, digitWidth, ligatureLevel, typographicCase) {
        if (fontDescription === void 0) { fontDescription = null; }
        if (fontSize === void 0) { fontSize = 12; }
        if (color === void 0) { color = 0; }
        if (alpha === void 0) { alpha = 1; }
        if (textRotation === void 0) { textRotation = 'auto'; }
        if (dominantBaseline === void 0) { dominantBaseline = 'roman'; }
        if (alignmentBaseline === void 0) { alignmentBaseline = 'useDominantBaseline'; }
        if (baselineShift === void 0) { baselineShift = 0; }
        if (kerning === void 0) { kerning = 'on'; }
        if (trackingRight === void 0) { trackingRight = 0; }
        if (trackingLeft === void 0) { trackingLeft = 0; }
        if (locale === void 0) { locale = 'en'; }
        if (breakOpportunity === void 0) { breakOpportunity = 'auto'; }
        if (digitCase === void 0) { digitCase = 'default'; }
        if (digitWidth === void 0) { digitWidth = 'default'; }
        if (ligatureLevel === void 0) { ligatureLevel = 'common'; }
        if (typographicCase === void 0) { typographicCase = 'default'; }
        var _this = _super.call(this) || this;
        console.log('create ElementFormat', fontSize, fontDescription === null || fontDescription === void 0 ? void 0 : fontDescription.fontName);
        _this._fontDescription = fontDescription;
        _this._fontSize = +fontSize;
        _this._color = color >>> 0;
        _this._alpha = +alpha;
        _this._textRotation = axCoerceString(textRotation);
        _this._dominantBaseline = axCoerceString(dominantBaseline);
        _this._alignmentBaseline = axCoerceString(alignmentBaseline);
        _this._baselineShift = +baselineShift;
        _this._kerning = axCoerceString(kerning);
        _this._trackingRight = +trackingRight;
        _this._trackingLeft = +trackingLeft;
        _this._locale = axCoerceString(locale);
        _this._breakOpportunity = axCoerceString(breakOpportunity);
        _this._digitCase = axCoerceString(digitCase);
        _this._digitWidth = axCoerceString(digitWidth);
        _this._ligatureLevel = axCoerceString(ligatureLevel);
        _this._typographicCase = axCoerceString(typographicCase);
        return _this;
    }
    Object.defineProperty(ElementFormat.prototype, "alignmentBaseline", {
        // AS -> JS Bindings
        get: function () {
            return this._alignmentBaseline;
        },
        set: function (alignmentBaseline) {
            this._alignmentBaseline = axCoerceString(alignmentBaseline);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "alpha", {
        get: function () {
            return this._alpha;
        },
        set: function (value) {
            this._alpha = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "baselineShift", {
        get: function () {
            return this._baselineShift;
        },
        set: function (value) {
            this._baselineShift = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "breakOpportunity", {
        get: function () {
            return this._breakOpportunity;
        },
        set: function (opportunityType) {
            this._breakOpportunity = axCoerceString(opportunityType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "color", {
        get: function () {
            return this._color;
        },
        set: function (value /*uint*/) {
            this._color = value >>> 0;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "dominantBaseline", {
        get: function () {
            return this._dominantBaseline;
        },
        set: function (dominantBaseline) {
            this._dominantBaseline = axCoerceString(dominantBaseline);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "fontDescription", {
        get: function () {
            return this._fontDescription;
        },
        set: function (value) {
            this._fontDescription = value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "digitCase", {
        get: function () {
            return this._digitCase;
        },
        set: function (digitCaseType) {
            this._digitCase = axCoerceString(digitCaseType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "digitWidth", {
        get: function () {
            return this._digitWidth;
        },
        set: function (digitWidthType) {
            this._digitWidth = axCoerceString(digitWidthType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "ligatureLevel", {
        get: function () {
            return this._ligatureLevel;
        },
        set: function (ligatureLevelType) {
            this._ligatureLevel = axCoerceString(ligatureLevelType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "fontSize", {
        get: function () {
            return this._fontSize;
        },
        set: function (value) {
            this._fontSize = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "kerning", {
        get: function () {
            return this._kerning;
        },
        set: function (value) {
            this._kerning = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "locale", {
        get: function () {
            return this._locale;
        },
        set: function (value) {
            this._locale = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "textRotation", {
        get: function () {
            return this._textRotation;
        },
        set: function (value) {
            this._textRotation = axCoerceString(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "trackingRight", {
        get: function () {
            return this._trackingRight;
        },
        set: function (value) {
            this._trackingRight = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "trackingLeft", {
        get: function () {
            return this._trackingLeft;
        },
        set: function (value) {
            this._trackingLeft = +value;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "typographicCase", {
        get: function () {
            return this._typographicCase;
        },
        set: function (typographicCaseType) {
            this._typographicCase = axCoerceString(typographicCaseType);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ElementFormat.prototype, "locked", {
        get: function () {
            return this._locked;
        },
        set: function (value) {
            this._locked = value;
        },
        enumerable: true,
        configurable: true
    });
    ElementFormat.prototype.getFontMetrics = function () {
        console.warn('[ElementFormat] - getFontMetrics not implemented');
        return null;
    };
    ElementFormat.forceNativeConstructor = true;
    ElementFormat.forceNativeMethods = true;
    return ElementFormat;
}(ASObject));
export { ElementFormat };
